<template>
  <div style="height:100vh;width:100vw;overflow:hidden;">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  data(){
    return{};
  },
  mounted() {
    console.log(process.env)
  }
}
</script>

<style>
</style>
